module.exports = __webpack_public_path__ + "img/totally-radio-00s.c0bb88b4.png";